import { IMAGE_URL } from '@/constant/IMAGE'
import Table from '@/components/common/Table'
import {
  BoxSearch,
  Button,
  ContainerCard,
  HeaderWrapper,
  IconSvg,
  SearchIcon,
  SearchInput,
} from './styles'
import DeleteApprovalClaimModal from '../DeleteApprovalClaimModal'
import TableApprovalHook from './TableApproval.hook'
import CreateApprovalClaimModal from '../CreateApprovalClaimModal'

const TableApproval = () => {
  const {
    columns,
    queryListHealthClaimUserApprove,
    onSearch,
    onTableChange,
    inputValue,
    validatePerm,
    BACKOFFICE_USER_PERMISSION,
    user,
    onHandleAddApproval,
  } = TableApprovalHook()

  return (
    <ContainerCard>
      <HeaderWrapper>
        <BoxSearch>
          <SearchInput
            placeholder="ค้นหาชื่อ, นามสกุล, รหัสพนักงาน"
            prefix={<SearchIcon />}
            value={inputValue}
            onChange={onSearch}
          />
        </BoxSearch>

        {validatePerm([BACKOFFICE_USER_PERMISSION.APP010102], user.permissions) ? (
          <Button
            type="primary"
            icon={<IconSvg src={IMAGE_URL.plusIcon} />}
            data-testid="system-approval-add-button"
            onClick={onHandleAddApproval}
          >
            เพิ่มผู้อนุมัติ
          </Button>
        ) : null}
      </HeaderWrapper>
      <Table
        columns={columns}
        dataSource={queryListHealthClaimUserApprove.data?.data}
        loading={queryListHealthClaimUserApprove.isLoading}
        pagination={{
          pageSizeOptions: [10, 25, 50, 100],
          showSizeChanger: true,
          total: queryListHealthClaimUserApprove.data?.meta.totalItems,
          current: queryListHealthClaimUserApprove.data?.meta.currentPage,
          defaultCurrent: 1,
          defaultPageSize: 10,
          pageSize: queryListHealthClaimUserApprove.data?.meta.itemsPerPage,
        }}
        onChange={(pagination) => onTableChange(pagination)}
      />
      <DeleteApprovalClaimModal />
      <CreateApprovalClaimModal />
    </ContainerCard>
  )
}

export default TableApproval
